import * as React from 'react';

import { UIHeading1, UIHeading2, UIHeading4, UIHeading3, UIText1, UIText2, UIText3 } from '@cian/ui-kit';

export type TSize = 'h1' | 'h2' | 'h3' | 'h4' | 'default' | 'small' | 'verySmall';
export type TColor = 'white' | 'black' | 'gray' | 'blue';

export interface IText {
  children: React.ReactNode;
  size?: TSize;
  color?: TColor;
  bold?: boolean;
  block?: boolean;
}

function getTextComponent(size: TSize) {
  switch (size) {
    case 'h1':
      return UIHeading1;
    case 'h2':
      return UIHeading2;
    case 'h3':
      return UIHeading3;
    case 'h4':
      return UIHeading4;
    case 'default':
      return UIText1;
    case 'small':
      return UIText2;
    case 'verySmall':
      return UIText3;
  }
}

function getColor(color: TColor) {
  switch (color) {
    case 'black':
      return 'black_100';
    case 'blue':
      return 'primary_100';
    case 'gray':
      return 'gray60_100';
    case 'white':
      return 'white_100';
  }
}

function getFontWeight(bold?: boolean) {
  return bold ? 'bold' : 'normal';
}

function getDisplay(block?: boolean) {
  return block ? 'block' : 'inline';
}

export function Text({ children, size = 'default', color = 'black', bold, block }: IText) {
  const TextComponent = getTextComponent(size);
  const textColor = getColor(color);
  const fontWeight = getFontWeight(bold);
  const display = getDisplay(block);

  return (
    <TextComponent color={textColor} fontWeight={fontWeight} display={display}>
      {children}
    </TextComponent>
  );
}
